import React, { useEffect, useState } from "react";
import { Sidebar, Menu, SubMenu, MenuItem } from "react-pro-sidebar";
import {
  PencilSquare,
  QuestionCircle,
  Book,
  BarChart,
  Record,
  Activity,
  HouseFill,
  GearFill,
  PersonPlus,
  BarChartSteps,
  PeopleFill,
  Cart,
  Clipboard2Fill,
} from "react-bootstrap-icons";
import ContentRouter from "../../../Route/ContentRouter";

import { useDispatch, useSelector } from "react-redux";
import "./Sidebar.css";
import { NavLink } from "react-router-dom";
import { Gear } from "react-bootstrap-icons";
import Footer from "../Footer/Footer";
import { utils } from "../../Store/Utils";
import Setting from "../../Site Setting/SettingLayout";
import { useSidebarCollapse } from "./SidebarCollapseContext";

const Sidebars = () => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const { collapsed, setCollapsed } = useSidebarCollapse();

  const handleShow = () => {
    dispatch(utils.settingLayout(true));
    setShow(true);
  };

  const selectedLayoutTheme = useSelector(
    (state) => state.colorTheme.layoutTheme
  );
  let layoutType;

  if (selectedLayoutTheme === "right-align-layout") {
    layoutType = true;
  } else {
    layoutType = false;
  }

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  });

  // On small screens, expand the sidebar again after a menu item is clicked
  const handleHide = () => {
    if (windowWidth <= 992) {
      setCollapsed(false);
    }
  };

  return (
    <>
      {/* <section
        className={
          selectedLayoutTheme === "right-align-layout"
            ? "right-side-setting-img"
            : "setting-img"
        }
      >
        <Gear onClick={handleShow} />
        {show && <Setting />}
      </section> */}

      <section
        className="layout-has-sidebar"
        style={{ direction: layoutType ? "rtl" : "ltr" }}
      >
        <Sidebar collapsed={collapsed} transitionDuration={1000} layoutType>
          <aside className="layout-sidebar-light">
            <Menu
              menuItemStyles={{
                button: ({ level, active, disabled }) => {
                  if (level === 0)
                    return {
                      color: disabled ? "#f5d9ff" : "#d359ff",
                      backgroundColor: active ? "#eecef9" : undefined,
                    };
                },
              }}
            >
              <span className="sidebar-main-menu">MAIN MENU</span>
              <MenuItem
                icon={<HouseFill />}
                component={
                  <NavLink onClick={handleHide} to={"/dashboard/widgets"} />
                }
              >
                Dashboard
              </MenuItem>
              <MenuItem
                icon={<Record />}
                component={
                  <NavLink onClick={handleHide} to={"/dashboard/reports"} />
                }
              >
                Reports
              </MenuItem>
              <MenuItem
                icon={<Activity />}
                component={
                  <NavLink
                    onClick={handleHide}
                    to={"/dashboard/activity-logs"}
                  />
                }
              >
                Activity Logs
              </MenuItem>
            </Menu>
          </aside>
        </Sidebar>

        <section className="main-layout">
          <ContentRouter />
          <Footer />
        </section>
      </section>
    </>
  );
};

export default Sidebars;
